import Kindergartens from "./Kindergartens";
export default Kindergartens;
